import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import SaveToWorkspaceComplex from '../../views/function-bar/SaveToWorkspaceComplex.vue';
import FamilySearchHeaderTitle from './FamilySearchHeaderTitle.vue';
import FamilySearchHeaderToggle from './FamilySearchHeaderToggle.vue';
import { useFamilySearch } from '@/composables/use-family-search';
import { useFamilySearchPage } from '@/composables/use-family-search-page';
import { useFamilySearchUrlParams } from '@/composables/use-family-search-url-params';
import { useFamilySearchPatentInfo } from '@/composables/use-family-search-patent-info';
import { useI18n } from '@/composables/use-i18n';
import { usePermission } from '@/composables/use-permission';


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilySearchHeader',
  setup(__props) {

const { permissions } = usePermission();

const { isFamilySearchFromWorkspace } = useFamilySearch();

const { isLoadingRoot: pageIsLoadingRoot, index: pageIndex, currentActiveItem: pageCurrentActiveItem } = useFamilySearchPage();
const { familySearchType } = useFamilySearchUrlParams();

const { patentInfo, isLoading: patentInfoIsLoading } = useFamilySearchPatentInfo();
const { t } = useI18n();

const patentId = computed(() => pageCurrentActiveItem.value.patent_id);

return { __sfc: true,permissions, isFamilySearchFromWorkspace, pageIsLoadingRoot, pageIndex, pageCurrentActiveItem, familySearchType, patentInfo, patentInfoIsLoading, t, patentId, SaveToWorkspaceComplex, FamilySearchHeaderTitle, FamilySearchHeaderToggle }
}

})